import { FC } from "react";
import { YesNoFormField } from "@blanket/components/formFields/FormFields";
import { JaNej } from "../../model/registrationEnums";
import { requiresLeavesOtherOnEntry } from "../../eligibility/participantEligibilityRules";

type LeavesOtherOnEntryFieldProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  leavesOtherOnEntry: string;
  label: string;
  helperWhenJa?: string;
};

export const LeavesOtherOnEntryField: FC<LeavesOtherOnEntryFieldProps> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  leavesOtherOnEntry,
  label,
  helperWhenJa,
}) => {
  if (!requiresLeavesOtherOnEntry(isLawyerOrLawFirm, passedPartnerExam)) {
    return null;
  }

  return (
    <YesNoFormField
      name={`${namePrefix}.leavesOtherOnEntry`}
      label={label}
      isRequired
      helperText={leavesOtherOnEntry === JaNej.Ja ? helperWhenJa : undefined}
      id={`${idPrefix}-leaves-other`}
    />
  );
};
